import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirlineStopsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airline_stops"}/>
}
